import React from "react"
import { ui } from "../../../shared/styles/uiSystem"

export default function DashboardContainer({
  hero,
  kpis = null,
  banners = null,
  children
}) {
  return (
    <div style={ui.page}>
      {hero}

      {kpis ? (
        <div style={{ marginBottom: 16 }}>
          {kpis}
        </div>
      ) : null}

      {banners}

      {children}
    </div>
  )
}